import { useState, type FormEvent } from 'react';
import { api } from '../api/client.js';
import type { User } from '@wml-insta/shared';
import { ModalPortal } from './ModalPortal.js';

interface Props {
  onClose: () => void;
  onChanged?: (nextToken: string, user: User) => void;
}

interface ChangePwResp {
  ok: true;
  token: string;
  user: User;
}

export function SelfPasswordModal({ onClose, onChanged }: Props) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    if (next !== confirm) {
      setErr('Пароли не совпадают');
      return;
    }
    if (next.length < 6) {
      setErr('Новый пароль минимум 6 символов');
      return;
    }
    setBusy(true);
    try {
      const resp = await api<ChangePwResp>('/api/auth/change-password', {
        method: 'POST',
        body: JSON.stringify({ currentPassword: current, newPassword: next }),
      });
      setDone(true);
      onChanged?.(resp.token, resp.user);
      setTimeout(onClose, 1200);
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Не удалось сменить пароль');
      setBusy(false);
    }
  }

  return (
    <ModalPortal>
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel" onClick={(e) => e.stopPropagation()}>
        <div className="modal-title">Сменить пароль</div>
        {done ? (
          <div style={{ padding: '12px 0', color: 'var(--text-muted)' }}>Пароль обновлён ✓</div>
        ) : (
          <form onSubmit={submit} style={{ display: 'grid', gap: 10 }}>
            <label className="field">
              <span>Текущий пароль</span>
              <input className="admin-input" type="password" required value={current} onChange={(e) => setCurrent(e.target.value)} autoFocus />
            </label>
            <label className="field">
              <span>Новый пароль</span>
              <input className="admin-input" type="password" required minLength={6} value={next} onChange={(e) => setNext(e.target.value)} />
            </label>
            <label className="field">
              <span>Повторите новый пароль</span>
              <input className="admin-input" type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} />
            </label>
            {err && <div className="error">{err}</div>}
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 4 }}>
              <button type="button" className="btn-secondary" onClick={onClose} disabled={busy}>Отмена</button>
              <button type="submit" className="btn-primary" disabled={busy} style={{ width: 'auto', padding: '0 20px' }}>Сменить</button>
            </div>
          </form>
        )}
      </div>
    </div>
    </ModalPortal>
  );
}
